import { getFunctions, httpsCallable } from "firebase/functions";
import type { AppUser } from "../types/User";

const functions = getFunctions();

let debounceTimer: NodeJS.Timeout | null = null;

// Pure JS date formatter
function getTodayDate() {
  const d = new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function setupUserVisitTracking(appUser: AppUser | null) {
  if (!appUser) return;
  if (appUser.role !== "user") return;

  const uid = appUser.uid;
  const today = getTodayDate();
  const sessionKey = `visit_${uid}_${today}`;

  // Already counted today
  if (sessionStorage.getItem(sessionKey)) return;

  // ---------- DEBOUNCE ----------
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }

  debounceTimer = setTimeout(async () => {
    try {
      const fn = httpsCallable(functions, "authUserHandler");
      await fn({ type: "loginSession", email: appUser.email });

      sessionStorage.setItem(sessionKey, "true");
    } catch (err) {
      console.error("Failed to record visit:", err);
    } finally {
      debounceTimer = null;
    }
  }, 500);  // 500ms debounce delay – safe, adjustable
}
